import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

export type MaiDrawerProps = {
  open: boolean;
  title: string;
  subtitle?: string | null;
  onClose: () => void;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  wide?: boolean;
};

export const MaiDrawer: React.FC<MaiDrawerProps> = ({
  open,
  title,
  subtitle,
  onClose,
  children,
  footer,
  wide,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="mai-drawer-backdrop" onClick={onClose} role="presentation">
      <aside
        className={`mai-drawer ${wide ? 'is-wide' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="mai-drawer-head">
          <div>
            <h2 className="mai-drawer-title">{title}</h2>
            {subtitle ? <p className="mai-drawer-sub">{subtitle}</p> : null}
          </div>
          <button type="button" className="mai-drawer-close" onClick={onClose} aria-label="Fechar">
            <FiX size={18} />
          </button>
        </header>
        <div className="mai-drawer-body">{children}</div>
        {footer ? <footer className="mai-drawer-footer">{footer}</footer> : null}
      </aside>
    </div>
  );
};

export default MaiDrawer;
